<header class="page-head">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-money"></i></span>
    <div>
      <h1 class="page-head__title">Pagamentos</h1>
    </div>
  </div>
  <div class="page-head__actions">
    <a routerLink="/partner" class="sf-btn sf-btn--secondary">
      <i class="fa fa-arrow-left"></i> Voltar
    </a>
  </div>
</header>

<div class="sf-card" *ngIf="next_payment">
  <div class="section-title">Próximo pagamento</div>
  <div class="def-grid">
    <div class="def">
      <dt>Data</dt>
      <dd>{{ next_payment.payment_date | date : "dd/MM/yyyy" }}</dd>
    </div>
    <div class="def">
      <dt>Valor</dt>
      <dd>{{ next_payment.amount | numberFormat : "R$ " : true }}</dd>
    </div>
  </div>
</div>

<div class="sf-card" *ngIf="payments$ | async as payments; else noPayments">
  <div class="section-title">Pagamentos realizados</div>
  <table class="table">
    <thead>
      <tr><th>Data</th><th>Valor</th><th>Tipo</th></tr>
    </thead>
    <tbody *ngIf="payments.data.length > 0; else noPayments">
      <tr *ngFor="let payment of payments.data">
        <td>{{ payment.payment_date | date : "dd/MM/yyyy" }}</td>
        <td>{{ payment.amount | numberFormat : "R$ " : true }}</td>
        <td>{{ payment.type }}</td>
      </tr>
    </tbody>
  </table>

  <app-pagination
    *ngIf="payments"
    look="v2"
    [currentPage]="payments.current_page"
    [itemsPerPage]="payments.per_page"
    [totalItems]="payments.total"
    (pageChanged)="pageChangedPayments($event)"
  >
  </app-pagination>
</div>

<div class="sf-card" *ngIf="pendingPaginate$ | async as pendingPaginate; else nopendingPaginate">
  <div class="section-title">Pagamentos pendentes</div>
  <table class="table">
    <thead>
      <tr><th>Data</th><th>Valor</th><th>Período</th></tr>
    </thead>
    <tbody *ngIf="pendingPaginate.data && pendingPaginate.data.length > 0; else nopendingPaginate">
      <tr *ngFor="let pending of pendingPaginate.data">
        <td>{{ pending.payment_date | date : "dd/MM/yyyy" }}</td>
        <td>{{ pending.amount | numberFormat : "R$ " : true }}</td>
        <td>{{ pending.period | period }}</td>
      </tr>
    </tbody>
  </table>
  <app-pagination
    *ngIf="pendingPaginate"
    look="v2"
    [currentPage]="pendingPaginate.current_page"
    [itemsPerPage]="pendingPaginate.per_page"
    [totalItems]="pendingPaginate.total"
    (pageChanged)="pageChangedPending($event)"
  ></app-pagination>
</div>

<ng-template #noPayments>
  <app-skeleton *ngIf="loadingPayments" variant="table-row" [count]="5" [columns]="4"
    label="Carregando os pagamentos" data-testid="payments-loading"></app-skeleton>

  <!-- `!loadingPayments` para o vazio não piscar antes da primeira resposta: era
       o overlay que escondia esse instante. -->
  <div class="sf-card empty" *ngIf="!loadingPayments">
    <i class="fa fa-money"></i>
    <p>Nenhum pagamento realizado até o momento.</p>
  </div>
</ng-template>

<ng-template #nopendingPaginate>
  <app-skeleton *ngIf="loadingPending" variant="table-row" [count]="5" [columns]="4"
    label="Carregando os pagamentos pendentes" data-testid="pending-loading"></app-skeleton>

  <div class="sf-card empty" *ngIf="!loadingPending">
    <i class="fa fa-hourglass-half"></i>
    <p>Sem pagamentos pendentes até o momento.</p>
  </div>
</ng-template>
